export default __webpack_public_path__ + "static/bagnard-webfont-f196068464b6adc199c2c9e56cb28e87.woff";